export class WFSVendorSelectorResultDto {
    vendorId: number;
    vendorName: string;
    active: boolean;
}
